const REDACT = "[redacted]";
const SENSITIVE_KEY = /password|passwd|secret|token|credential|authorization|x-vybe-password/i;

/**
 * Strip sensitive fields from objects before persisting to the in-app journal.
 */
export function sanitizeForJournal(data: unknown): unknown {
  if (data === null || data === undefined) return data;
  if (typeof data !== "object") return data;
  if (Array.isArray(data)) return data.map(sanitizeForJournal);
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(data as Record<string, unknown>)) {
    if (SENSITIVE_KEY.test(k)) {
      out[k] = REDACT;
    } else if (typeof v === "object" && v !== null) {
      out[k] = sanitizeForJournal(v) as unknown;
    } else {
      out[k] = v;
    }
  }
  return out;
}
